import { useMemo } from "react";
import { useTournamentContext } from "../../../../hook/context";
import { EditTournamentTab } from "../../../../hook/useTournamentTab";
import { EditTournamentTabItem, EditTournamentTabWrapper } from "../../style";

const EditTournamentTabs = () => {
  const { setTournamentTab, isTournamentTab, tournamentId } =
    useTournamentContext();

  const tabs = useMemo(() => {
    if (tournamentId) {
      return [
        { tab: EditTournamentTab.BASE, name: "토너먼트 기본 설정" },
        { tab: EditTournamentTab.PRIZE, name: "프라이즈 설정" },
        { tab: EditTournamentTab.PARTICIPATION, name: "참가 설정" },
        { tab: EditTournamentTab.STRUCTURE, name: "스트럭쳐 설정" },
      ];
    }
    return [
      { tab: EditTournamentTab.BASE, name: "토너먼트 기본 설정" },
      { tab: EditTournamentTab.PRIZE, name: "프라이즈 설정" },
      { tab: EditTournamentTab.PARTICIPATION, name: "참가 설정" },
      { tab: EditTournamentTab.STRUCTURE, name: "스트럭쳐 설정" },
      { tab: EditTournamentTab.RESERVATION, name: "예약 설정" },
    ];
  }, [tournamentId]);

  return (
    <EditTournamentTabWrapper>
      {tabs.map((t, i) => (
        <EditTournamentTabItem
          key={i}
          selected={isTournamentTab(t.tab)}
          onClick={() => setTournamentTab(t.tab)}
        >
          {t.name}
        </EditTournamentTabItem>
      ))}
    </EditTournamentTabWrapper>
  );
};

export default EditTournamentTabs;
